{
  "UnreturnedCallsFilterSectionTitle": "Unreturned Calls Filtering",
  "UnreturnedCallsFilterSectionDesc": "You can also control which kinds of inbound calls are included in the \"Unreturned Lost Calls\" reports",

  "UnreturnedCallsFilter_IncludeEscapedLabel": "Include Escaped To Calls:",
  "UnreturnedCallsFilter_IncludeDivertedOverflowedLabel": "Include Diverted/Overflowed To Calls:",
  "UnreturnedCallsFilter_IncludeTransferredLabel": "Include Transferred To Calls:",
  "UnreturnedCallsFilter_IncludeAllOtherLabel": "Include all other Calls:",

  "NAME": "UnreturnedCallsFilter"
}
